import parsePhoneNumber, { CountryCode } from "libphonenumber-js";

type Props = {
  label: string;
  countryCode?: CountryCode;
};

function PhoneNumber({ label, countryCode = "FR" }: Props) {
  const phoneNumber = parsePhoneNumber(label ?? "", countryCode);
  if (phoneNumber) {
    return <span>{phoneNumber.formatNational()}</span>;
  }

  return <span>{label}</span>;
}

export default PhoneNumber;
